// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-treatmentAndWelfare__items":"jobSearchDetail-treatmentAndWelfare__items"};